import { createCn } from "cn/config"

/*
 * `cn`, taught Beacon's own utilities. The merge behind it only knows Tailwind's defaults, and it
 * reads an unknown `text-*` as a colour: bare `cn("text-ui text-muted-foreground")` keeps the colour
 * and silently drops the size, and `cn("text-xs", "text-ui")` keeps both. The same goes for the
 * elevation shadows and the easing curve. Each group below names the scale `tokens.css` defines, so
 * a later class of the same kind replaces an earlier one as it does for Tailwind's own.
 *
 * Import `cn` from here, never from the `cn` package, anywhere a class string holds one of these.
 */
export const cn = createCn({
  extend: {
    classGroups: {
      "font-size": [{ text: ["2xs", "ui", "prose", "title", "heading", "display", "stat"] }],
      shadow: [{ shadow: ["raised", "panel", "popover", "dialog", "drag", "button"] }],
      ease: [{ ease: ["snappy"] }],
    },
  },
})
